export const PENDING = 'pending';
export const FULFILLED = 'fulfilled';
export const REJECTED = 'rejected';
export const SEARCH = 'search';
export const FILTER = 'filter';
export const APPLY = 'apply';
export const SAVE = 'save';
export const ADD = 'add';
export const DELETE = 'delete';
export const UPLOAD = 'upload';
export const CREATE_ACT_REVISION = 'createActOfRevision';
export const CREATE_CLAIM = 'createClaim';
export const CREATE_PAYMENT_SCHEDULE = 'createPaymentSchedule';
export const NEED_HELP = 'needHelp';
export const ACCEPT_CARD = 'acceptCard';
export const CARD_DIDNT_MATCH = 'cardDidntMatch';
export const CHAT = 'chat';
export const CHANGE_VIEW = 'changeView';
export const GO_TO_ORGANIZER = 'goToOrganizer';
export const GO_TO_CASCADE = 'goToCascade';
export const GO_TO_CONSTRUCTION_CARDS = 'goToConstructionCards';
export const GO_TO_SHIPMENTS = 'goToShipments';

export const CascadeReportAction = {
  SEND_EMAIL: 'sendEmail',
  DOWNLOAD_FILE: 'downloadFile',
};
